import { http } from '@platzi/commons';
import { API_URL } from 'src/env';
import { schoolsApi } from '../services/api';

export const getHeader = (headers) => {
  return http.axiosServerInstance(headers).get(schoolsApi.server.header);
};

export const getIdentity = (headers) => {
  return http.axiosServerInstance(headers).get(schoolsApi.server.identity);
};

export const getExplore = (headers) => {
  return http.axiosServerInstance(headers).get(schoolsApi.server.explore);
};

export const getContactInfo = (headers) => {
  return http.axiosServerInstance(headers).get(schoolsApi.server.contactInfo);
};

export const getPriceTable = (headers) => {
  return http.axiosServerInstance(headers).get(schoolsApi.client.tablePrice);
}

export const getSchool = (slug: string) => {
  return http.axiosInstance().get(API_URL + schoolsApi.server.school(slug));
};

export const getCommunityInfo = (slug: string) => {
  return http.axiosInstance().get(API_URL + schoolsApi.server.community(slug));
};

export const getRoute = (slug: string) => {
  return http.axiosInstance().get(API_URL + schoolsApi.server.route(slug));
};

export const getFollowSchools = () => {
  return http.axiosInstance(true).get(schoolsApi.client.schools.getFollowSchools);
};

export const followSchool = (schoolId: number, payload) => {
  return http.axiosInstance(true).post(schoolsApi.client.schools.followSchool(schoolId), payload);
};

export const unFollowSchool = (schoolId: number) => {
  return http.axiosInstance(true).delete(schoolsApi.client.schools.unFollowSchool(schoolId));
};

export const getPlacementTest = (schoolSlug: string) => {
  return http.axiosInstance(true).get(schoolsApi.client.schools.placement_test(schoolSlug));
};

export const getRoutesProgress = (schoolSlug: string) => {
  return http.axiosInstance(true).get(schoolsApi.client.schools.routesProgress(schoolSlug));
};

export const saveEmail = (payload) => {
  return http.axiosInstance().post(schoolsApi.client.registerEmail, payload);
};

export const getUserPlans = () => {
  return http.axiosInstance().get(schoolsApi.client.userPlans);
}

export const getB2bPlans = () => {
  return http.axiosInstance().get(schoolsApi.client.b2bPlans);
};

export const getRouteProgress = (id: number) => {
  return http.axiosInstance().get(schoolsApi.client.routes.routeProgress(id));
};
